module.exports = __webpack_public_path__ + "static/media/sologo.603acd68.png";